export default {

    install (Vue) {

        const _vm = new Vue({
            data () {
                return {}
            }
        })

        Vue.mixin({
            computed: {

                $referencias () { return _vm.$data }

            },
            beforeCreate () {

                if (this.$addRef) return

                this.$addRef = (key, data) => {

                    if (!_vm.$data) _vm.$data = {}

                    _vm.$data[key] = data

                }

            }
        })

    }

}